module.exports = __webpack_public_path__ + "img/single_bidding.1c5fac0c.png";